
export const isEmptyObject = (obj) => {
  try {
    return Object.keys(obj).length === 0 && obj.constructor === Object  
  } catch {
    return false
  }
}